import { useSelector } from "react-redux";

// Layout constants — single source of truth for page spacing
const CONTAINER_MARGIN_START = "4vw";
const CONTAINER_MARGIN_END = "4vw";

const PageLayout = ({ className = "", style = {}, as: Component = "div", children, ...rest }) => {
  const direction = useSelector((state) => state.mode.direction);

  return (
    <Component
      className={`container page page-layout-content ${className}`.trim()}
      dir={direction}
      style={{
        "--page-bottom-space": "16px",
        "--container-margin-start": CONTAINER_MARGIN_START,
        "--container-margin-end": CONTAINER_MARGIN_END,
        ...style,
      }}
      {...rest}
    >
      {children}
    </Component>
  );
};

export default PageLayout;
